const state = function() {
  return {
    protocolVuexData: null,
    protocolVersion: 0
  };
};

export default state;


// WEBPACK FOOTER //
// ./src/modules/dashboardParent/vuex/state.js